import script from "./ReclassifiedPL.vue?vue&type=script&setup=true&lang=js"
export * from "./ReclassifiedPL.vue?vue&type=script&setup=true&lang=js"

import "./ReclassifiedPL.vue?vue&type=style&index=0&id=56cfc75a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56cfc75a"]])

export default __exports__